<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elevation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to Company Menu" @click="$router.push('/company')">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="attendance" :pageId="helpPageId" color="white"></help-link>
                    <v-menu left v-model="menu_status" offset-y> 
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" dark v-on="on">
                                &nbsp;&nbsp;CY {{selectedFiscalYear}}&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-tile v-for="(item,index) in fiscal_years" :key="index" :title="`Calendar Year ${item.fiscalYear}`" @click="setSelectedYear(item.fiscalYear)">
                                <v-list-tile-title small>CY {{item.fiscalYear}}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </v-toolbar>
            </v-card>
            <v-card class="elevation-1 mt-5"> 
                <v-toolbar flat height="45px">
                    <div :class="isMobile?'wp-50 mb-10':'wp-30 mb-10'">
                        <v-text-field v-model="search" append-icon="search" label="Search date" single-line hide-details clearable></v-text-field>
                    </div>
                    <v-spacer></v-spacer>
                    <b>Select Cutoff Period</b>
                </v-toolbar>
                <!-- by cutoff -->
                <v-data-table
                    :headers="isMobile ? headers_mobile: headers"
                    :items="attendance_corrections_summary_filtered"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync"
                >
                    <template v-slot:items="props">
                        <tr @click="viewCutoffDetails(props.item)" class="clickable" title="Click to view timesheet for this period">
                            <td v-if="!isMobile">
                                <span class="font-weight-bold">{{props.item.cutOffPeriodDesc}}</span>
                            </td>
                            <td v-if="isMobile">{{ getCutoffCoverageDescription(props.item.cutOffStart, props.item.cutOffEnd) }}</td>
                            <td v-if="!isMobile">{{ props.item.cutOffStart | moment("YYYY-MM-DD") }}</td>
                            <td v-if="!isMobile">{{ props.item.cutOffEnd | moment("YYYY-MM-DD") }}</td>
                            <td>
                                <b :class="commonfn.getStatusColor(props.item.cutOffStatus)">{{commonfn.getStatusDescription(props.item.cutOffStatus)}}</b>
                            </td>
                        </tr>
                    </template>
                </v-data-table> 
            </v-card>
        </v-flex>
    </v-layout> 
</template>

<script>

import attendanceCorrectionsApi from '@/api/attendancecorrection'
import commonfn from '@/common/functions'
import { getSort, getRowsPerPage, getSearchKeyword, getCalendarYear, updateCalendarYear, updateRowsPerPage, updateSort, updateSearchKeyword } from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'
import { getCutoffCoverageDescription } from '@/helpers/cutoff-format'

export default {     
    name: 'AttendanceCorrections',
    metaInfo: {
        title: 'Attendance Corrections',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Attendance Corrections' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
        ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
    },   
    data () {
        const routeName = this.$route.name
        const savedSort = getSort(routeName)

        return {
            commonfn,
            rowsPerPageItems,
            getCutoffCoverageDescription,
            paginationSync: {
                rowsPerPage: getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            search: getSearchKeyword(routeName),
            selectedFiscalYear: getCalendarYear(routeName),
            headers: [
                {text: 'Period',align: 'left',value: 'cutOffPeriodDesc', width: '10%', sortable:true},
                {text: 'Cutoff Start Date',align: 'left',value: 'cutoffStart', width: '10%', sortable:true},
                {text: 'Cutoff End Date',align: 'left',value: 'cutoffEnd', width: '10%', sortable:true},
                {text: 'Cutoff Status',align: 'left',value: 'cutOffStatus',  width: '10%', sortable:true},
            ],
            headers_mobile: [
                {text: 'Cutoff Period',align: 'left',value: 'cutoffStart', width: '10%', sortable:true},
                {text: 'Cutoff Status',align: 'left',value: 'status',  width: '10%', sortable:true}
            ],
            error: false,
            errorMessage: '',
            loading: false,
            attendance_corrections_summary: [],
            attendance_corrections_all: [],
            menu_status: false,
        }
    },
    methods: {
        setSelectedYear(fiscalYear) {
            this.selectedFiscalYear = fiscalYear
             updateCalendarYear(this.$route.name, fiscalYear)
            this.getAllAttendanceCorrections()
        },
        viewCutoffDetails(data) {
            this.$router.push(`/${this.accessedFrom}/corrections/${data.cutOffId}`)
        },  
        viewDetails(data) {
            if (this.$store.state.userId == data.userId) {
                this.$router.push(`/myattendance/corrections/details/${data.attendanceCorrectionsId}`)
            }else{
                this.$router.push(`/${this.accessedFrom}/corrections/details/${data.attendanceCorrectionsId}`)
            }
        }, 
        async getAttendanceCorrectionsSummary() {
            try {
                this.loading = true
                const response = await attendanceCorrectionsApi.getSummaryByCompany()     
                if (response && response.status == 200) {
                    this.attendance_corrections_summary = response.data.summaryItems
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        }, 
    },
    async created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Company Attendance Corrections'
        })

        await this.getAttendanceCorrectionsSummary()
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        },
        search(newVal) {
            updateSearchKeyword(this.$route.name, newVal)
        }
    },
    computed: {
        attendance_corrections_summary_filtered() {
            var temp = this.attendance_corrections_summary.filter(item => {
                return (item.fiscalYear==this.selectedFiscalYear && !item.cutOffPeriodDesc.includes('Upcoming'))
            })
            if (this.search) {
                temp = temp.filter(item => {
                    return ( item.cutOffStart.includes(this.search))
                })
            }
            return temp //.reverse()
        },
        fiscal_years() {
            if (this.$store.state.fiscalPeriods) {
                return this.$store.state.fiscalPeriods
            }
            return [{fiscalYear: new Date().getFullYear()}]
        },
        accessedFrom() {
            return 'company'
        },
        helpPageId() {
            return 'attendance-corrections-review-company'
        }
    }
}
</script>